import { Anchor, Checkbox, Text } from "@mantine/core";
import { HiCheck } from "react-icons/hi";
import { useTranslation } from "react-i18next";

interface IProps {
  acceptTerm: boolean | undefined;
  handleAcceptTerm: () => void;
  link: string;
}

export default function AcceptProductTerms({
  acceptTerm = false,
  handleAcceptTerm,
  link,
}: IProps) {
  const { t } = useTranslation();

  return (
    <Checkbox
      color="primary.1"
      size="md"
      icon={HiCheck}
      onChange={handleAcceptTerm}
      checked={acceptTerm}
      label={
        <Text>
          {t("global.accept_terms.text")}
          <Anchor href={link} target="_blank">
            {t("global.accept_terms.terms_of_use_product")}
          </Anchor>
        </Text>
      }
    />
  );
}
